let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("b1RNi")).then(() => parcelRequire('g1IzC'));